import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {ErrorLog} from '../../interfaces/core/error-log';
import {db} from '../db.service';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {ErrorLogFactory} from '../../factories/core/error-log-factory';


@Injectable({
  providedIn: 'root'
})
export class ErrorLogsTable extends SecureTable<ErrorLog> {
  constructor() {
    super(db.errorLogs);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'default',
      dependencies: [],
      adapter: new DefaultAdapter<ErrorLog>({
        api: ['error-logs'],
        fromObject: ErrorLogFactory.fromObject,
        toRemote: ErrorLogFactory.toRemote
      })
    };
  }

  /**
   * Entfernt alle bereits hochgeladenen Error-Logs samt Queue-Einträgen lokal (keine Server-Deletes).
   * Nicht hochgeladene Logs bleiben erhalten, bis der Sync sie übertragen hat.
   */
  public async pruneSynced(): Promise<void> {
    const syncStatusItems = await db.syncStatusItems
      .where('tableName').equals(this.table.name)
      .filter(_syncStatusItem =>
        _syncStatusItem.isSynced === 1 && _syncStatusItem.deleted === 0 && _syncStatusItem.isSyncing === 0)
      .toArray();

    if(syncStatusItems.length <= 0) {
      return;
    }
    await this.removeMany(syncStatusItems.map(_syncStatusItem => _syncStatusItem.primaryKey), true);
  }
}
